module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "top-nav"
  }, [_c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": "1",
      "mode": "horizontal"
    },
    on: {
      "select": _vm.handleSelect
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22,
      "offset": 1
    }
  }, [('logo' in _vm.top) ? _c('router-link', {
    attrs: {
      "to": "/home"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_c('img', {
    staticClass: "nsp-logo",
    attrs: {
      "src": 'static/' + _vm.top.logo
    }
  })])], 1) : _vm._e(), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/doc"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_vm._v("Documentation")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/api"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_vm._v("API")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/download"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_vm._v("Download")])], 1), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:wj_hust08@hust.edu.cn?cc=yxiao@hust.edu.cn"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_vm._v("Contact\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "line"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-17b44d5a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopNav.vue
// module id = 87
// module chunks = 2